// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb-list":"breadcrumb-list___3OiDQ","breadcrumb-container":"breadcrumb-container___2dzq_","breadcrumbs":"breadcrumbs___2t3tN","clear-all":"clear-all___3eTEh","selected-filter":"selected-filter___1fm2k","filter-text":"filter-text___2ljHR","keyword-crumb":"keyword-crumb___39GoB","full-text":"full-text___2cH8P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breadcrumb/BreadcrumbList.scss
// module id = C5B+
// module chunks = 46